import { render, staticRenderFns } from "./courseEvaluation.vue?vue&type=template&id=562c4fc2&scoped=true"
import script from "./courseEvaluation.vue?vue&type=script&lang=js"
export * from "./courseEvaluation.vue?vue&type=script&lang=js"
import style0 from "./courseEvaluation.vue?vue&type=style&index=0&id=562c4fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562c4fc2",
  null
  
)

export default component.exports